import { Suspense } from "react"
import { Outlet } from "react-router-dom"
import styles from "./bottom-menu-layout.module.css"
import BottomMenu from "@/components/bottom-menu/bottom-menu.tsx"
import { LoadingAnimation } from "@/components/loading-animation/loading-animation.tsx"

const BottomMenuLayout = () => {
  return (
    <>
      <div className={styles.suspenseWrapper}>
        <Suspense
          fallback={
            <LoadingAnimation
              className={"h-[calc(100dvh - var(--bottom-menu-height))] w-full"}
            />
          }
        >
          <Outlet />
        </Suspense>
      </div>
      <BottomMenu />
    </>
  )
}

export default BottomMenuLayout
